/**
 *  © 2024-2025 DXC Technology, all rights reserved.
 *  Material published by DXC Technology on these web pages/mobile
 *  app may not be reproduced without permission.
 */

/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { useMutvListingValue } from '../../../context/mutvMyListContext';
import CarouselMyListListing from '../Show/CarouselMyListListing';
import NoDataFound from './NoDataFound';
import { useSponsorValue } from '../../../context/sponsorContext';
import Sticky from '../../../utils/sticky';
import { getNode } from '../mutvutil';
import { withTranslation } from 'react-i18next';
import DropdownFilterList from '../../../utils/DropdownFilterList';
const CarouselMyList = (props) => {
  const {
    t,
    cmsData,
    allData,
    tabSelected,
    loadMore,
    noDataFound,
    totalData,
    onDeleteItem,
    idsToDeletes,
    deleteAndUndoDelete,
    editAndDone,
    undoDeleteState,
    showDeleteBtn,
    isNewMyListing,
    clickSortChange,
    getSliceTo,
    myListResultFetchError,
  } = props;
  useEffect(() => {
    setIsClientside(true);
  }, []);
  const MylistHeadline = cmsData?.fields?.MylistHeadline?.value;
  const SavedItemsCTATitle = cmsData?.fields?.SavedItemsCTATitle?.value;
  const SaveItemsCTAURL = cmsData?.fields?.SaveItemsCTAURL?.value;
  const SavedItemsTitle = cmsData?.fields?.SavedItemsTitle?.value;
  const SaveItemsAsCarousal = cmsData?.fields?.SaveItemsAsCarousal?.value;
  const DisplaySavedItems = cmsData?.fields?.DisplaySavedItems?.value;
  const ContinueWatchingCTATitle = cmsData?.fields?.ContinueWatchingCTATitle?.value;
  const ContinueWatchingCTAURL = cmsData?.fields?.ContinueWatchingCTAURL?.value;
  const ContinueWatchingTitle = cmsData?.fields?.ContinueWatchingTitle?.value;
  const ContinueWatchingAsCarousal = cmsData?.fields?.ContinueWatchingAsCarousal?.value;
  const DisplayContinueWatching = cmsData?.fields?.DisplayContinueWatching?.value;
  const isDetailsListView = !SaveItemsAsCarousal && !ContinueWatchingAsCarousal;
  const ContinueWatchingFilters =
    cmsData?.fields?.ContinueWatchingFilters?.value &&
    typeof cmsData.fields.ContinueWatchingFilters.value === 'string'
      ? JSON.parse(cmsData.fields.ContinueWatchingFilters.value)?.sort((a, b) =>
          a.key.localeCompare(b.key)
        )
      : Array.isArray(cmsData.fields.ContinueWatchingFilters.value) &&
        cmsData.fields.ContinueWatchingFilters.value?.sort((a, b) => a.key.localeCompare(b.key));

  const SaveItemsFilters =
    cmsData?.fields?.SaveItemsFilters?.value &&
    typeof cmsData.fields.SaveItemsFilters.value === 'string'
      ? JSON.parse(cmsData.fields.SaveItemsFilters.value)?.sort((a, b) =>
          a.key.localeCompare(b.key)
        )
      : Array.isArray(cmsData.fields.SaveItemsFilters.value) &&
        cmsData.fields.SaveItemsFilters.value?.sort((a, b) => a.key.localeCompare(b.key));

  const [{ itemNumber, status }, dispatch] = useMutvListingValue();
  const [{ isLoginChecked, isUserLogin }] = useSponsorValue();
  const [isClientside, setIsClientside] = useState(false);
  const initialState = {
    contentList: {
      data: [],
      listLoader: false,
      startIndex: 0,
      status: null,
    },
    contentHistory: {
      data: [],
      listLoader: false,
      startIndex: 0,
      status: null,
    },
  };
  const [filteredData, setFilteredData] = useState({ contentList: '', contentHistory: '' });
  const [contentToShow, setContentToShow] = useState(initialState);
  const defaultFilterContentList =
    SaveItemsFilters?.length > 0 && SaveItemsFilters[0]?.key?.toLowerCase() === 'all'
      ? SaveItemsFilters[0]?.key
      : null;
  const [activeFilterContentList, setActiveFilterContentList] = useState(defaultFilterContentList);
  const defaultFilterContentHistory =
    ContinueWatchingFilters?.length > 0 && ContinueWatchingFilters[0]?.key?.toLowerCase() === 'all'
      ? ContinueWatchingFilters[0]?.key
      : null;
  const [activeFilterContentHistory, setActiveFilterContentHistory] = useState(
    defaultFilterContentHistory
  );
  const [showFilteredDataContentList, setShowFilteredDataContentList] = useState(false);
  const [showFilteredDataContentHistory, setShowFilteredDataContentHistory] = useState(false);

  useEffect(() => {
    if (allData['contentList']?.data?.length > 0 || allData['contentHistory']?.data?.length > 0) {
      if (allData['contentList']?.data?.length > 0) {
        const loadmore = allData['contentList']?.data?.length > itemNumber ? true : false;
        setContentToShow((prevState) => ({
          ...prevState,
          contentList: {
            data: allData['contentList']?.data?.slice(0, itemNumber),
            status: 'fetched',
            listLoader: loadmore,
            startIndex: 0,
          },
        }));
      }
      if (allData['contentHistory']?.data?.length > 0) {
        const loadmore = allData['contentHistory']?.data?.length > itemNumber ? true : false;
        setContentToShow((prevState) => ({
          ...prevState,
          contentHistory: {
            data: allData['contentHistory']?.data?.slice(0, itemNumber),
            status: 'fetched',
            listLoader: loadmore,
            startIndex: 0,
          },
        }));
      }
      sortFilterData(allData);
    }
  }, [allData]);

  const filterdAll = (filteredData) => {
    const allCount = filteredData?.All?.length;
    if (allCount > 0) {
      const nonEmptyItems = Object.values(filteredData).filter((arr) => arr.length > 0);
      if (nonEmptyItems?.length === 2) {
        if (nonEmptyItems[0]?.length === nonEmptyItems[1]?.length) {
          delete filteredData.All;
        }
      }
    }
  };

  const sortFilterData = (allData) => {
    if (SaveItemsFilters?.length > 0 && allData['contentList']?.data?.length > 0) {
      const contentListFilteredData = handleFilterData(
        SaveItemsFilters,
        allData['contentList'].data,
        'contentList'
      );
      if (contentListFilteredData) {
        //if count of 'All' and another any one filter matches and
        // expect this two items others count is 0 then delete 'All' from object list
        filterdAll(contentListFilteredData);
        setFilteredData((prevState) => ({
          ...prevState,
          contentList: contentListFilteredData,
        }));
        if (showFilteredDataContentList) {
          handleFilterClick(null, activeFilterContentList, 'contentList', contentListFilteredData);
        }
      }
    }

    if (ContinueWatchingFilters?.length > 0 && allData['contentHistory']?.data?.length > 0) {
      const contentHistoryFilteredData = handleFilterData(
        ContinueWatchingFilters,
        allData['contentHistory'].data,
        'contentHistory'
      );
      if (contentHistoryFilteredData) {
        //if count of 'All' and another any one filter matches and
        // expect this two items others count is 0 then delete 'All' from object list
        filterdAll(contentHistoryFilteredData);
        setFilteredData((prevState) => ({
          ...prevState,
          contentHistory: contentHistoryFilteredData,
        }));
        if (showFilteredDataContentHistory) {
          handleFilterClick(
            null,
            activeFilterContentHistory,
            'contentHistory',
            contentHistoryFilteredData
          );
        }
      }
    }
  };

  const handleFilterData = (myListFilter, myListData, contentType) => {
    const filteredResults = {};
    myListFilter.forEach((filterItem) => {
      if (filterItem?.key) filteredResults[filterItem.key] = [];

      if (filterItem?.key?.toLowerCase() === 'all') {
        filteredResults[filterItem.key] = myListData;
      } else if (
        filterItem?.key?.toLowerCase() === 'continuewatching' &&
        allData['contentHistory']?.data?.length > 0
      ) {
        // which exist in watch list
        filteredResults[filterItem.key] = allData['contentHistory'].data;
      } else if (filterItem?.key?.toLowerCase() === 'other') {
        // Now, handle the "Other" category to add elements not matched by any filter
        myListData.forEach((dataItem) => {
          let isMatched = false;

          // Check if this dataItem matches any filter (excluding "Other")
          myListFilter.forEach((item) => {
            if (
              item?.key !== 'Other' &&
              item?.valueToMatch?.length > 0 &&
              item?.valueToMatch?.some((val) => val?.trim() !== '')
            ) {
              const valueToMatch = item?.valueToMatch;
              if (
                valueToMatch?.some((val) =>
                  dataItem?.taglist_sm?.some((tag) => tag?.startsWith(val))
                )
              ) {
                isMatched = true;
              }
            }
          });

          // If it doesn't match any filter, add it to the "Other" category
          if (!isMatched) {
            filteredResults[filterItem.key].push(dataItem);
          }
        });
      }

      const valueToMatch = filterItem?.valueToMatch;

      if (valueToMatch?.length > 0 && valueToMatch?.some((val) => val?.trim() !== '')) {
        // Check each item in myData to see if any of its taglist_sm values match the valueToMatch
        myListData.forEach((dataItem) => {
          // If any tag in dataItem matches one of the values in valueToMatch
          if (
            valueToMatch.some((val) => dataItem?.taglist_sm?.some((tag) => tag?.startsWith(val)))
          ) {
            // Add the matched dataItem to the appropriate key in filteredResults
            filteredResults[filterItem.key].push(dataItem);
          }
        });
      }
    });
    return filteredResults;
  };

  const handleFilterClick = (e, filterKey, type, contentData) => {
    if (e) {
      e.preventDefault();
    }
    let obj;
    if (type === 'contentList') {
      setActiveFilterContentList(filterKey);
      setShowFilteredDataContentList(true);
      setShowFilteredDataContentHistory(false);
      obj = contentData[filterKey];
      const loadmore = obj?.length > itemNumber ? true : false;
      setContentToShow((prevState) => ({
        ...prevState,
        contentList: {
          data: obj?.slice(0, itemNumber),
          status: 'fetched',
          listLoader: loadmore,
          startIndex: 0,
        },
      }));
    }
    if (type === 'contentHistory') {
      setActiveFilterContentHistory(filterKey);
      setShowFilteredDataContentHistory(true);
      setShowFilteredDataContentList(false);
      obj = contentData[filterKey];
      const loadmore = obj?.length > itemNumber ? true : false;
      setContentToShow((prevState) => ({
        ...prevState,
        contentHistory: {
          data: obj?.slice(0, itemNumber),
          status: 'fetched',
          listLoader: loadmore,
          startIndex: 0,
        },
      }));
    }
  };

  const myDropBoxContentList = [
    { recentlyAdded: t('RecentlyAdded') },
    { newest: t('Newest') },
    { oldest: t('Oldest') },
  ];

  const myDropBoxContentHistory = [
    { recentlyWatched: t('RecentlyWatched') },
    { newest: t('Newest') },
    { oldest: t('Oldest') },
  ];

  const checkToShowNoData = () => {
    if ((tabSelected === 'contentList' || tabSelected === 'contentHistory') && isLoginChecked) {
      return totalData ? checkConetentLength() : true;
    }
    return false;
  };

  const checkConetentLength = () => {
    const obj = getNode(totalData, tabSelected);
    if (obj) {
      const contentlength = obj.filter((item) => !item.hasOwnProperty('deletedDT'));
      if (isLoginChecked && isUserLogin) {
        return contentlength.length === 0 && status === 'fetched' ? true : false;
      } else {
        return contentlength.length === 0 ? true : false;
      }
    }
  };

  const newLoadMore = (isAutoScroll) => {
    if (undoDeleteState || isAutoScroll) {
      setContentToShow({
        ...contentToShow,
        contentList: {
          ...contentToShow['contentList'],
          status: 'fetching',
          listLoader: false,
        },
        contentHistory: {
          ...contentToShow['contentHistory'],
          status: 'fetching',
          listLoader: false,
        },
      });

      setTimeout(() => {
        let obj;
        if (tabSelected === 'contentList') {
          if (showFilteredDataContentList) {
            obj = filteredData['contentList'][activeFilterContentList];
          } else {
            obj = allData['contentList']?.data;
          }
          let getSliceToVal = getSliceTo(obj, 0);
          const initial = contentToShow['contentList']?.data?.length;
          const loadmore = obj?.length - initial > itemNumber ? true : false;
          setContentToShow((prevState) => ({
            ...prevState,
            contentList: {
              data: obj?.slice(0, initial + getSliceToVal),
              status: 'fetched',
              listLoader: loadmore,
              startIndex: initial,
            },
          }));
        }
        if (tabSelected === 'contentHistory') {
          if (showFilteredDataContentHistory) {
            obj = filteredData['contentHistory'][activeFilterContentHistory];
          } else {
            obj = allData['contentHistory']?.data;
          }
          let getSliceToVal = getSliceTo(obj, 0);
          const initial = contentToShow['contentHistory']?.data?.length;
          const loadmore = obj?.length - initial > itemNumber ? true : false;
          setContentToShow((prevState) => ({
            ...prevState,
            contentHistory: {
              data: obj?.slice(0, initial + getSliceToVal),
              status: 'fetched',
              listLoader: loadmore,
              startIndex: initial,
            },
          }));
        }
        //getMyLists(state[tabSelected].startIndex + itemNumber, tabSelected, totalData);
      }, 1000);
    }
  };

  const cardDataContentList = isDetailsListView
    ? contentToShow['contentList']?.data
    : contentToShow['contentList']?.data?.slice(0, 8);
  const cardDataContentHistory = isDetailsListView
    ? contentToShow['contentHistory']?.data
    : contentToShow['contentHistory']?.data?.slice(0, 8);

  const contentListTab = (
    <CarouselMyListListing
      containerType={'containerType'}
      aspectRatio={'4x3'}
      status={contentToShow['contentList'].status}
      cardData={cardDataContentList}
      listView={false}
      showLoadMore={contentToShow['contentList'].listLoader}
      loadMore={loadMore}
      showLoader={true}
      initialLoad={itemNumber}
      isContinueCard={false}
      showDeleteBtn={showDeleteBtn}
      onDeleteItem={onDeleteItem}
      idsToDeletes={idsToDeletes}
      mylistPage={true}
      isDetailsListView={isDetailsListView}
      newLoadMore={newLoadMore}
    />
  );

  const contentHistoryTab = (
    <CarouselMyListListing
      containerType={'containerType'}
      aspectRatio={'4x3'}
      status={contentToShow['contentHistory'].status}
      cardData={cardDataContentHistory}
      listView={false}
      showLoadMore={contentToShow['contentHistory'].listLoader}
      loadMore={loadMore}
      showLoader={true}
      initialLoad={itemNumber}
      isContinueCard={true}
      showDeleteBtn={showDeleteBtn}
      onDeleteItem={onDeleteItem}
      idsToDeletes={idsToDeletes}
      mylistPage={true}
      isDetailsListView={isDetailsListView}
      newLoadMore={newLoadMore}
    />
  );

  return (
    <React.Fragment>
      <div className={`myListContenBox ${isDetailsListView && 'isDetailsListView'}`}>
        <div className="mylist newMyListing">
          <div className="mutv-shows__filter">
            <Sticky>
              <div className="container mutv-container filters mylist">
                {isClientside && (
                  <div className="mutv-shows__filter__nav item-my-lists">
                    <React.Fragment>
                      <div className="topPanel">
                        <h2 className={`heading ${isDetailsListView && 'highlight'}`}>
                          {!isDetailsListView
                            ? MylistHeadline
                              ? MylistHeadline
                              : t('Mylist')
                            : DisplaySavedItems
                            ? SavedItemsTitle &&
                              `${SavedItemsTitle} ${
                                allData['contentList']?.data?.length > 0
                                  ? `(${allData['contentList']?.data.length})`
                                  : ''
                              }`
                            : DisplayContinueWatching &&
                              ContinueWatchingTitle &&
                              `${ContinueWatchingTitle} ${
                                allData['contentHistory']?.data?.length > 0
                                  ? `(${allData['contentHistory']?.data.length})`
                                  : ''
                              }`}
                        </h2>
                      </div>
                    </React.Fragment>

                    {isDetailsListView &&
                      (cardDataContentList?.length > 0 ||
                        cardDataContentHistory?.length > 0 ||
                        !undoDeleteState) && (
                        <div className="actions">
                          {showDeleteBtn && (
                            <button className="btn bdr" onClick={() => deleteAndUndoDelete()}>
                              {!undoDeleteState ? t('UndoDelete') : t('DeleteSelected')}
                            </button>
                          )}
                          <button className="btn" onClick={() => editAndDone()}>
                            {!showDeleteBtn ? t('Edit') : t('Done')}
                          </button>
                        </div>
                      )}
                  </div>
                )}
              </div>
            </Sticky>
          </div>
        </div>

        {!myListResultFetchError && (
          <div className="mylist mylist-cards newMyListing">
            {((noDataFound &&
              isLoginChecked &&
              (tabSelected === 'contentList' || tabSelected === 'contentHistory')) ||
              checkToShowNoData()) && <NoDataFound isNewMyListing={isNewMyListing}></NoDataFound>}
            {((isDetailsListView && DisplaySavedItems && cardDataContentList?.length > 0) ||
              (!isDetailsListView && SaveItemsAsCarousal && cardDataContentList?.length > 0)) && (
              <div className="myCarousel myCarouselContentList">
                <div className="container">
                  <div className="content">
                    {!isDetailsListView && SavedItemsCTATitle && (
                      <a href={SaveItemsCTAURL ? SaveItemsCTAURL : ''}>
                        <span className="btn">{SavedItemsCTATitle}</span>
                      </a>
                    )}
                    {!isDetailsListView && SavedItemsTitle && (
                      <h4>{`${SavedItemsTitle} ${
                        allData['contentList']?.data?.length > 0
                          ? `(${allData['contentList']?.data?.length})`
                          : ''
                      }`}</h4>
                    )}
                    {SaveItemsFilters?.length > 0 &&
                      Object.keys(filteredData['contentList'])?.length > 0 && (
                        <div className="filterBox">
                          {SaveItemsFilters.map((filter, ind) => {
                            if (
                              filter.value &&
                              filteredData['contentList'][filter.key]?.length > 0
                            ) {
                              const filterTitle = filter.value;
                              const isActive = activeFilterContentList === filter.key; // Check if this filter is active
                              return (
                                <a
                                  href="#"
                                  key={ind}
                                  onClick={(e) =>
                                    handleFilterClick(
                                      e,
                                      filter.key,
                                      'contentList',
                                      filteredData['contentList']
                                    )
                                  }
                                  className={isActive ? 'active' : ''}
                                >
                                  <span>
                                    {isActive &&
                                    isDetailsListView &&
                                    filteredData['contentList'][filter.key]?.length > 0
                                      ? `${filterTitle} (${
                                          filteredData['contentList'][filter.key]?.length
                                        })`
                                      : filterTitle}
                                  </span>
                                </a>
                              );
                            }
                          })}
                        </div>
                      )}
                    {isDetailsListView && cardDataContentList?.length > 0 && (
                      <div className="sorting_content">
                        <div className="dropbox__select">
                          <DropdownFilterList
                            listData={myDropBoxContentList}
                            clickSortChange={clickSortChange}
                            contentType="contentList"
                            activeFilterContent={activeFilterContentList}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  {contentListTab}
                </div>
              </div>
            )}
            {((isDetailsListView &&
              DisplayContinueWatching &&
              cardDataContentHistory?.length > 0) ||
              (!isDetailsListView &&
                ContinueWatchingAsCarousal &&
                cardDataContentHistory?.length > 0)) && (
              <div className="myCarousel myCarouselContentHistory">
                <div className="container">
                  <div className="content">
                    {!isDetailsListView && ContinueWatchingCTATitle && (
                      <a href={ContinueWatchingCTAURL ? ContinueWatchingCTAURL : ''}>
                        <span className="btn">{ContinueWatchingCTATitle}</span>
                      </a>
                    )}
                    {!isDetailsListView && ContinueWatchingTitle && (
                      <h4>{`${ContinueWatchingTitle} ${
                        allData['contentHistory']?.data?.length > 0
                          ? `(${allData['contentHistory']?.data?.length})`
                          : ''
                      }`}</h4>
                    )}
                    {ContinueWatchingFilters?.length > 0 &&
                      Object.keys(filteredData['contentHistory'])?.length > 0 && (
                        <div className="filterBox">
                          {ContinueWatchingFilters.map((filter, ind) => {
                            if (
                              filter.value &&
                              filteredData['contentHistory'][filter.key]?.length > 0
                            ) {
                              const filterTitle = filter.value;
                              const isActive = activeFilterContentHistory === filter.key; // Check if this filter is active
                              return (
                                <a
                                  href="#"
                                  key={ind}
                                  onClick={(e) =>
                                    handleFilterClick(
                                      e,
                                      filter.key,
                                      'contentHistory',
                                      filteredData['contentHistory']
                                    )
                                  }
                                  className={isActive ? 'active' : ''}
                                >
                                  <span>
                                    {isActive &&
                                    isDetailsListView &&
                                    filteredData['contentHistory'][filter.key]?.length > 0
                                      ? `${filterTitle} (${
                                          filteredData['contentHistory'][filter.key]?.length
                                        })`
                                      : filterTitle}
                                  </span>
                                </a>
                              );
                            }
                          })}
                        </div>
                      )}
                    {isDetailsListView && cardDataContentHistory?.length > 0 && (
                      <div className="sorting_content">
                        <div className="dropbox__select">
                          <DropdownFilterList
                            listData={myDropBoxContentHistory}
                            clickSortChange={clickSortChange}
                            contentType="contentHistory"
                            activeFilterContent={activeFilterContentHistory}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  {contentHistoryTab}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(CarouselMyList);
